import React, { useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnPlPackage from '@zxcvbn-ts/language-pl';
import { MDBCol, MDBProgress, MDBProgressBar, MDBRow } from 'mdb-react-ui-kit';
import { ExclamationTriangle } from 'styled-icons/bootstrap';

import { FormikMdbField } from './form.component';
import { LoadingSpinner, MDBCustomAlert } from './mdb-custom.component';
import {
    DangerBtn, PrimaryBtn, SecondaryBtn, SuccessBtn
} from './buttons.component';
import {
    ClientChangePasswordSendApi, ClientChangePasswordTokenApi, ClientLoginApi
} from '../../api/api-client';



export const LoginForm = () => {
    const [loginError, setLoginError] = useState('');
    let history = useHistory();

    const loginValidationSchema = Yup.object().shape({
        username: Yup.string().required('Pole jest wymagane'),
        password: Yup.string().required('Pole jest wymagane'),
    });

    async function loginSubmit(values) {
        setLoginError('');
        try {
            const result = await new ClientLoginApi({
                username: values.username,
                password: values.password
            }).post()
            if (result.status === 200) {
                sessionStorage.setItem('access', result.data.access);
                sessionStorage.setItem('login', values.username);
                history.push("/start");
            }
        }
        catch (e) {
            if (e.response) {
                setLoginError("Niepoprawny login lub hasło!");
            } else if (e.request) {
                setLoginError("Błąd połączenia z serwerem. Spróbuj ponownie później.")
            } else {
                setLoginError("Wystąpił nieznany błąd.")
            }
        }
    }

    return <Formik
        initialValues={{ username: '', password: '' }}
        validationSchema={loginValidationSchema}
        onSubmit={loginSubmit}
    >
        {({ touched, errors, isSubmitting }) =>
            <Form>
                <MDBCustomAlert color='danger' show={loginError}
                                setFeedback={setLoginError}>
                    <h5 className='m-0'><strong>{loginError}</strong></h5>
                </MDBCustomAlert>
                {isSubmitting ? <LoadingSpinner />
                    : <>
                    <FormikMdbField name="username" label="Login" size="lg"
                        touched={touched} errors={errors} />
                    <FormikMdbField type="password" name="password" label="Hasło"
                        size="lg" touched={touched} errors={errors} />
                    </>
                }
                <PrimaryBtn type="submit" block size='lg' disabled={isSubmitting}>
                    Zaloguj
                </PrimaryBtn>
            </Form>
        }
    </Formik>
}

export const LoginFormDiv = ({ showReset }) =>
    <>
        <LoginForm />
        <MDBRow className='mt-4'>
            <MDBCol size='auto'>
                <small>Jeśli nie pamiętasz hasła, kliknij tu:</small>
            </MDBCol>
            <MDBCol size='auto'>
                <SecondaryBtn size='sm' onClick={showReset}>
                    Resetuj hasło
                </SecondaryBtn>
            </MDBCol>
        </MDBRow>
    </>


export const ResetPasswdInitForm = ({ showLogin }) => {
    const [resetInitSuccess, setResetInitSuccess] = useState('');
    const [resetInitError, setResetInitError] = useState('');

    const resetPasswdInitValidationSchema = Yup.object().shape({
        username: Yup.string().required('Pole jest wymagane'),
        email: Yup.string().email('Email jest niepoprawny')
            .required('Pole jest wymagane'),
    });

    async function resetPasswdInitSubmit(values) {
        setResetInitError('');
        setResetInitSuccess('');
        try {
            const result = await new ClientChangePasswordSendApi(values).post();
            if (result.status === 200) {
                setResetInitSuccess('Link aktywacyjny został wysłany.');
            } else {
                setResetInitError(
                    'Użytkownik lub e-mail nie istnieje. Upewnij się, że podany e-mail jest zarejestrowany w systemie.'
                );
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status >= 500) {
                    setResetInitError('Wewnętrzny błąd serwera');
                } else if (error.response.status === 404) {
                    setResetInitError(
                        'Użytkownik lub e-mail nie istnieje. Upewnij się, że podany e-mail jest zarejestrowany w systemie.'
                    );
                }
            } else {
                setResetInitError('Błąd połączenia z serwerem. Spróbuj ponownie później.');
            }
        }
    }

    return <Formik
        initialValues={{ username: '', email: '' }}
        validationSchema={resetPasswdInitValidationSchema}
        onSubmit={resetPasswdInitSubmit}
    >
        {({ touched, errors, isSubmitting }) =>
            <Form>
                <MDBCustomAlert color='danger' show={resetInitError}
                                setFeedback={setResetInitError}>
                    <h5 className='m-0'><strong>{resetInitError}</strong></h5>
                </MDBCustomAlert>
                <MDBCustomAlert color='success' show={resetInitSuccess}
                                setFeedback={setResetInitSuccess}>
                    <h5 className='m-0'><strong>{resetInitSuccess}</strong></h5>
                </MDBCustomAlert>
                {isSubmitting && <LoadingSpinner />}
                {!isSubmitting && !resetInitSuccess && <>
                    <FormikMdbField name="username" label="Login" size="lg"
                        touched={touched} errors={errors} />
                    <FormikMdbField type="mail" name="email" label="E-mail"
                        size="lg" touched={touched} errors={errors} />
                    </>
                }
                <MDBRow>
                    <MDBCol>
                        {!resetInitSuccess && <PrimaryBtn type="submit" block
                            disabled={isSubmitting}>
                            Wyślij link aktywacyjny
                        </PrimaryBtn>}
                    </MDBCol>
                    <MDBCol size='auto'>
                        <SecondaryBtn type='button' onClick={showLogin}>
                            Cofnij
                        </SecondaryBtn>
                    </MDBCol>
                </MDBRow>
            </Form>
        }
    </Formik>
}


export const ResetPasswdForm = ({ username, token, onResetSuccess }) => {
    const [resetSuccess, setResetSuccess] = useState('');
    const [resetError, setResetError] = useState('');
    const [tokenError, setTokenError] = useState(false);
    const [passwdScore, setPasswdScore] = useState(null);
    const [passwdScoreWarning, setPasswdScoreWarning] = useState('');
    const [passwdScoreSuggestion, setPasswdScoreSuggestion] = useState('');

    const resetPasswdValidationSchema = Yup.object().shape({
        newPassword: Yup.string()
            .min(12, 'Hasło musi mieć co najmniej 12 znaków')
            .required('Pole jest wymagane'),
        repeatedNewPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Hasła nie są identyczne')
            .required('Pole jest wymagane'),
    });

    zxcvbnOptions.setOptions({
        translations: zxcvbnPlPackage.translations,
        graphs: zxcvbnCommonPackage.adjacencyGraphs,
        dictionary: {
            ...zxcvbnCommonPackage.dictionary,
            ...zxcvbnPlPackage.dictionary,
        },
    });
//     console.log(zxcvbn('dupa1234'));

    function ratePassword(value) {
        if (value === '') {
            setPasswdScore(null);
            setPasswdScoreWarning('');
            setPasswdScoreSuggestion('');
            return false;
        }
        let rateResult = zxcvbn(value);
        setPasswdScore(rateResult.score);
        setPasswdScoreWarning(rateResult.feedback.warning);
        setPasswdScoreSuggestion(rateResult.feedback.suggestions);
        return false;
    }

    async function resetPasswdSubmit(values) {
        setResetSuccess('');
        setResetError('');
        setTokenError(false);
        try {
            const result = await new ClientChangePasswordTokenApi({
                username: username,
                token: token,
                new_password: values.newPassword
            }).post();
            if (result.status === 200) {
                setResetSuccess('Hasło zostało ustawione');
                onResetSuccess();
            } else {
                let content = result.data.detail;
                if (!content) {
                    content = result.data;
                }
                setResetError(content);
            }
        } catch (e) {
            if (e.response) {
                let content = e.response.data.detail;
                if (!content) {
                    content = e.response.data;
                }
                setResetError(content);
                if (e.response.status === 404) {
                    setTokenError(true);
                }
            } else if (e.request) {
                setResetError("Błąd połączenia z serwerem. Spróbuj ponownie później.")
            } else {
                setResetError("Wystąpił nieznany błąd.")
            }
        }
    }

    const PasswordScoreBar = () => {
        let color = 'danger';
        if (passwdScore >= 4) {
            color = 'success';
        }
        else if (passwdScore >= 2) {
            color = 'warning';
        }
        return <MDBProgress height='40' className='mb-3'>
            <MDBProgressBar striped bgColor={color} className='fw-bold'
                width={passwdScore ? passwdScore * 25 : 2} valuemin={0} valuemax={100}>
                {passwdScore >= 2 && <>SIŁA HASŁA</>}
            </MDBProgressBar>
            <MDBProgressBar striped bgColor='transparent'
                className='text-dark fw-bold' width={passwdScore < 2 ? 75: 0}
                valuemin={0} valuemax={100}>
                SIŁA HASŁA
            </MDBProgressBar>
        </MDBProgress>
    }


    return <Formik
        initialValues={{ newPassword: '', repeatedNewPassword: '' }}
        validationSchema={resetPasswdValidationSchema}
        onSubmit={resetPasswdSubmit}
    >
        {({ touched, errors, isSubmitting }) =>
            <Form>
                <MDBCustomAlert color='danger' show={resetError}
                                setFeedback={setResetError}>
                    <h5 className='m-0'><strong>{resetError}</strong></h5>
                     {tokenError && <div className='text-start mt-3'>
                        <ExclamationTriangle height='1.5rem' />
                        Link aktywacyjny może być użyty <b>tylko raz</b>.
                        <p>
                            Jeśli chcesz zresetować hasło ponownie, wygeneruj
                            <DangerBtn type='button' size='sm' className='ms-3'
                                       href='/passwd_reset_init/'>
                                Nowy link
                            </DangerBtn>
                        </p>
                    </div>}
                </MDBCustomAlert>

                <MDBCustomAlert color='success' show={resetSuccess}
                                setFeedback={setResetSuccess}>
                    <h5 className='m-0'><strong>{resetSuccess}</strong></h5>
                    <SuccessBtn type='button' href='/' className='mt-5'>
                        Przejdź do strony logowania
                    </SuccessBtn>
                </MDBCustomAlert>
                {isSubmitting && <LoadingSpinner />}
                {!isSubmitting && !resetSuccess && <>
                    {passwdScore != null && <PasswordScoreBar />}
                    {passwdScoreWarning && <div>{ passwdScoreWarning }</div>}
                    {passwdScoreSuggestion && <div>{ passwdScoreSuggestion }</div>}
                    <FormikMdbField type="password" name="newPassword" size="lg"
                        label="Nowe hasło" touched={touched} errors={errors}
                        validate={ratePassword} />
                    <FormikMdbField type="password" name="repeatedNewPassword"
                        label="Powtórz nowe hasło" size="lg" touched={touched}
                        errors={errors} />
                    <PrimaryBtn type="submit" size='lg' disabled={isSubmitting}>
                        Ustaw hasło
                    </PrimaryBtn>
                    </>
                }
            </Form>
        }
    </Formik>
}
